import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { PersonEngagement } from '@interfaces';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<PersonEngagement> {

	return {
		rowName: { singular: 'Engagement', plural: 'Engagements' },
		getRowKey: row => '' + row.engagementId,
		stateKey: 'person-explorer-engagements-grid',
		actions: getActions(),
		buttons: getButtons(),
		columns: getColumns(util),
	}
}
